export class ResetPasswordDto {
    userName: string;
    password: string;
    recoveryAnswers: string[];
}
